import en from '@vueform/vueform/locales/en'
import { defineConfig } from '@vueform/vueform/src/core.js'
import RecaptchaElement from './RecaptchaElement.vue'
// import MaskPlugin from '@vueform/plugin-mask'
import MaskPlugin from './plugins/plugin-mask'


//custom theme import and tree shaking


//imports from core library
import {
  // Mandatory form components
  Vueform,
  FormElements,

  // Essential form components (optional)
  FormErrors,
  FormMessages,

  // Essential element components (optional)
  ElementLayout,
  ElementLayoutInline,
  ElementLoader,
  ElementLabelFloating,
  ElementLabel,
  ElementInfo,
  ElementDescription,
  ElementError,
  ElementMessage,
  ElementText,
  ElementAddon,
  ElementAddonOptions,
  ElementRequired,

  // Optional form components (optional)
  FormLanguages,
  FormLanguage,
  FormTabs,
  FormTab,
  FormSteps,
  FormStepsControls,
  FormStepsControl,
  FormStep,

  // Elements (optional)
  ButtonElement,
  CaptchaElement,
  CheckboxElement,
  CheckboxgroupElement,
  DateElement,
  DatesElement,
  FileElement,
  GroupElement,
  HiddenElement,
  ListElement,
  LocationElement,
  MultifileElement,
  MultiselectElement,
  ObjectElement,
  PhoneElement,
  RadioElement,
  RadiogroupElement,
  SelectElement,
  SignatureElement,
  SliderElement,
  StaticElement,
  TagsElement,
  TextareaElement,
  TextElement,
  ToggleElement,
  EditorElement,
  TTextareaElement,
  TTextElement,
  TEditorElement,

  // Element partials & wrappers (optional)
  DragAndDrop,
  CheckboxgroupCheckbox,
  RadiogroupRadio,
  FilePreview,
  DatepickerWrapper,
  EditorWrapper,

  // Alternative views (optional)
  CheckboxgroupElement_tabs,
  CheckboxgroupElement_blocks,
  CheckboxgroupCheckbox_tabs,
  CheckboxgroupCheckbox_blocks,
  FilePreview_image,
  FilePreview_gallery,
  RadiogroupRadio_tabs,
  RadiogroupRadio_blocks,
  RadiogroupElement_tabs,
  RadiogroupElement_blocks,

  // Mandatory imports
  classes,
  columns,
} from '@vueform/vueform/themes/vueform'

import {
  accepted,
  active_url,
  after,
  after_or_equal,
  alpha,
  alpha_dash,
  alpha_num,
  array,
  before,
  before_or_equal,
  between,
  boolean,
  captcha,
  completed,
  confirmed,
  date,
  date_equals,
  date_format,
  different,
  digits,
  digits_between,
  dimensions,
  distinct,
  email,
  exists,
  file,
  filled,
  gt,
  gte,
  image,
  in_,
  in_array,
  integer,
  ip,
  ipv4,
  ipv6,
  json,
  lt,
  lte,
  max,
  mimes,
  mimetypes,
  min,
  not_in,
  not_regex,
  nullable,
  numeric,
  regex,
  required,
  same,
  size,
  string,
  timezone,
  unique,
  url,
  uuid,
} from '@vueform/vueform/src/core.js'

//end imports from core library


//create custom theme and rules

const customTheme = {
  templates: {
    // Mandatory form components
    Vueform,
    FormElements,

    // Essential form components (optional)
    FormErrors,
    FormMessages,

    // Essential element components (optional)
    ElementLayout,
    ElementLayoutInline,
    ElementLoader,
    ElementLabelFloating,
    ElementLabel,
    ElementInfo,
    ElementDescription,
    ElementError,
    ElementMessage,
    ElementText,
    ElementAddon,
    ElementAddonOptions,
    ElementRequired,

    // Optional form components (optional)
    FormLanguages,
    FormLanguage,
    FormTabs,
    FormTab,
    FormSteps,
    FormStepsControls,
    FormStepsControl,
    FormStep,

    // Elements (optional)
    ButtonElement,
    CaptchaElement,
    CheckboxElement,
    CheckboxgroupElement,
    // DateElement,
    // DatesElement,
    FileElement,
    GroupElement,
    HiddenElement,
    ListElement,
    // LocationElement,
    MultifileElement,
    MultiselectElement,
    // ObjectElement,
    PhoneElement,
    RadioElement,
    RadiogroupElement,
    SelectElement,
    SignatureElement,
    //SliderElement,
    StaticElement,
    TagsElement,
    TextareaElement,
    TextElement,
    ToggleElement,
    // EditorElement,
    // TTextareaElement,
    // TTextElement,
    // TEditorElement,

    // Element partials & wrappers (optional)
    DragAndDrop,
    CheckboxgroupCheckbox,
    RadiogroupRadio,
    FilePreview,
    // DatepickerWrapper,
    // EditorWrapper,

    // Alternative views (optional)
    CheckboxgroupElement_tabs,
    CheckboxgroupElement_blocks,
    CheckboxgroupCheckbox_tabs,
    CheckboxgroupCheckbox_blocks,
    // FilePreview_image,
    // FilePreview_gallery,
    RadiogroupRadio_tabs,
    RadiogroupRadio_blocks,
    RadiogroupElement_tabs,
    RadiogroupElement_blocks,
  },
  
  classes,
  columns
}



const customRules = {
  accepted,
  active_url,
  // after,
  // after_or_equal,
  alpha,
  alpha_dash,
  alpha_num,
  array,
  // before,
  // before_or_equal,
  between,
  boolean,
  captcha,
  completed,
  confirmed,
  // date,
  // date_equals,
  // date_format,
  different,
  digits,
  digits_between,
  // dimensions,
  distinct,
  email,
  exists,
  file,
  filled,
  gt,
  gte,
  // image,
  in_,
  in_array,
  integer,
  ip,
  ipv4,
  ipv6,
  json,
  lt,
  lte,
  max,
  mimes,
  mimetypes,
  min,
  not_in,
  not_regex,
  nullable,
  numeric,
  regex,
  required,
  same,
  size,
  string,
  // timezone,
  unique,
  url,
  uuid,
};

//end custom theme and rules

//end custom theme import and tree shaking

export default defineConfig({
  theme: customTheme,
  rules: customRules,
  locales: { en },
  locale: 'en',
  plugins:[ MaskPlugin  ],
  endpoints: {
    submit: {
      url: '/form-api/submit/debug',
      method: 'post',
    },
    uploadTempFile: {
      url: '/form-api/file/upload-temp',
      method: 'post',
    },
    removeTempFile: {
      url: '/form-api/file/remove-temp',
      method: 'post',
    },
  },
  elements: [
    RecaptchaElement
  ]
})